
const CURRENCY_INFO = {
  '604': { alpha3: 'PEN', exponent: 2, symbol: 'S/' },
  '840': { alpha3: 'USD', exponent: 2, symbol: '$' }
};

const getCurrencyInfo = (numericCode) => {
  const info = CURRENCY_INFO[String(numericCode)];
  if (!info) {
    throw new Error(`Moneda no soportada: ${numericCode}`);
  }
  return info;
};

export const getCurrencyAlpha = (numericCode) => getCurrencyInfo(numericCode).alpha3;
export const getCurrencyExponent = (numericCode) => getCurrencyInfo(numericCode).exponent;
export const getCurrencySymbol = (numericCode) => getCurrencyInfo(numericCode).symbol;

export const getCurrencySymbolSafe = (numericCode) => {
  const info = CURRENCY_INFO[String(numericCode)];
  return info ? info.symbol : '';
};

export const formatAmountPart = (amountMinor, exponent, part) => {
  if (amountMinor === null || amountMinor === undefined) return '';
  let s = String(amountMinor).trim().replace(/[.,]/g, '');
  if (!/^\d+$/.test(s)) return '';
  if (exponent > 0) s = s.padStart(exponent, '0');
  const dec = exponent > 0 ? s.slice(-exponent) : '';
  let intPart = exponent > 0 ? s.slice(0, -exponent) : s;
  intPart = intPart.replace(/^0+/, '');
  if (intPart === '') intPart = '0';
  return part === 'integer' ? intPart : dec;
};

export const formatAmountDecimal = (amountMinor, numericCode) => {
  const exponent = getCurrencyExponent(numericCode);
  const digits = String(amountMinor).trim().replace(/[.,]/g, '');
  if (!/^\d+$/.test(digits)) {
    throw new Error(`Monto invalido: ${amountMinor}`);
  }
  if (exponent === 0) {
    return String(parseInt(digits, 10));
  }
  const padded = digits.padStart(exponent + 1, '0');
  const intPart = padded.slice(0, -exponent).replace(/^0+(?=\d)/, '');
  const decPart = padded.slice(-exponent);
  return `${intPart}.${decPart}`;
};
